var pillHeights = {
    default: '20px',
    large: '24px',
};
var getPillHeight = function (height, size, tiny) {
    if (height)
        return height;
    if (tiny)
        return "8px";
    return pillHeights[size] || pillHeights.default;
};
export default getPillHeight;
